module.exports = __webpack_public_path__ + "img/music-experience.02ba5357.svg";